module.exports = __webpack_public_path__ + "static/media/google-play-badge.8539a2fe.svg";